module.exports = __webpack_public_path__ + "static/img/p7.f187d73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/parkServices/p7.jpg
// module id = EJHk
// module chunks = 1